{
  "receiving": {
    "search": {
      "label": "ابحث برقم الأمر"
    },
    "notIssuedTitle": "لم يصدر هذا الأمر بعد",
    "notIssuedBody": "لا يمكن استلام البضاعة إلا مقابل أمر شراء صادر. بعد إصدار الأمر للمورد، عد إلى هنا لتسجيل ما يصل.",
    "cancelledTitle": "أُلغي هذا الأمر",
    "cancelledBody": "لا يمكن استلام شيء آخر مقابل أمر ملغى. ما وصل قبل الإلغاء مدرج أدناه.",
    "openOrder": "فتح الأمر"
  }
}
